export default {"src":"/_next/static/media/icon-x.68e1c796.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};